import {DashboardOverView} from "../../../kpi/overview/dashboardOverView";
import {DashboardStatCard} from "../../../kpi/overview/dashboardStatCard";
import {faBan, faCalendar, faChartSimple, faStar, faWater} from "@fortawesome/free-solid-svg-icons";
import {SmartTriggerConfiguration} from "../../types";
import {useEffect, useState} from "react";
import {Loader} from "../../../loader/Loader";
import {useAuth} from "../../../../providers/AuthProvider";
import {getSmartTriggers} from "../../service/smartTriggerService";
import "./smartTriggerDashboard.css"
import {ActionIcon} from "@mantine/core";
import {CirclePlus, X} from "tabler-icons-react";
import {SmartTriggerCard} from "./card/smartTriggerCard";
import {random} from "../../../../utils/utils";
import {AddNewSmartTriggerCard} from "./card/addNewSmartTriggerCard";

type SmartTriggerDashboardState = {
    configurations: SmartTriggerConfiguration[],
    isLoading: boolean,
    total: number,
    active: number,
    scheduled: number,
    reactive: number,
    filters: string[]
    errors: string | undefined | null,
    inactive: number
}

const filterRegistry: Record<string, (configuration: SmartTriggerConfiguration) => boolean> = {
    'active': configuration => configuration.activeStatus === 'ACTIVE',
    'scheduled': configuration => configuration.tags.includes('scheduled'),
    'reactive': configuration => configuration.tags.includes('reactive'),
    'inactive': configuration => configuration.activeStatus === 'INACTIVE'
}

const getStats = (configurations: SmartTriggerConfiguration[]) => {
    const stats = {
        active: 0,
        scheduled: 0,
        reactive: 0,
        total: 0,
        inactive: 0
    }
    for (const config of configurations) {
        stats.total = stats.total + 1
        if (config.activeStatus === 'ACTIVE') {
            stats.active = stats.active + 1
        } else {
            stats.inactive = stats.inactive + 1;
        }
        if (config.tags.includes("scheduled")) {
            stats.scheduled = stats.scheduled + 1;
        }
        if (config.tags.includes("reactive")) {
            stats.reactive = stats.reactive + 1;
        }
    }
    return stats;
}

const colors = ["cyan", "red", "blue", "orange"]

const pickRandomColor = () => {
    return colors[random(colors.length)]
}

const filterConfiguration = (configuration: SmartTriggerConfiguration, filters: string[]) => {
    if (filters.length === 0) {
        return true;
    }
    return filters.every(filter => filterRegistry[filter](configuration));
}

export function SmartTriggerDashboard() {

    const authContext = useAuth();

    const [state, setState] = useState<SmartTriggerDashboardState>({
        configurations: [],
        isLoading: true,
        errors: undefined,
        filters: [],
        active: 0,
        reactive: 0,
        total: 0,
        scheduled: 0,
        inactive: 0
    });


    useEffect(() => {
        async function fetchSmartTriggers() {
            try {
                const smartTriggers = await getSmartTriggers(authContext);
                const stats = getStats(smartTriggers)
                setState(state => ({...state, isLoading: false, ...stats, configurations: smartTriggers}))
            } catch (error) {
                setState(state => ({...state, isLoading: false, errors: "something went wrong"}))
            }
        }

        fetchSmartTriggers();

    }, []);


    const addFilter = (name: string) => {
        if (name === 'all') {
            setState(state => ({...state, filters: []}))
            return;
        }
        setState(state => {
            const uniqueFilters = new Set<string>(state.filters)
            uniqueFilters.add(name)
            const filters = Array.from(uniqueFilters)

            return {...state, filters}
        })
    }

    const removeFilter = (name: string) => {
        if (name === 'all') {
            setState(state => ({...state, filters: []}))
            return;
        }
        setState(state => {
            const filters = state.filters.filter(item => item !== name)
            return {...state, filters}
        })
    }


    if (state.isLoading) {
        return <Loader/>
    }

    if (state.errors) {
        return <h1>{state.errors}</h1>
    }

    const removeButton = (name: string) => (
        <ActionIcon onClick={() => removeFilter(name)} size="xs" color="blue" radius="xl" variant="transparent">
            <X size={10}/>
        </ActionIcon>
    );

    return (
        <>
            <div className="smart-trigger-header">

                <div className={"smart-trigger-header-left"}>
                    <h3 className={"smart-trigger-header-title"}>Smart Flows</h3>
                    <p>Create & Manage all of your smart flows in one place with Sales code dashboard.</p>

                </div>
                <div className={"smart-trigger-header-right"}>
                    <button className={"create-flow-button"}>
                        <CirclePlus/> Create Flow
                    </button>
                </div>

            </div>
            <DashboardOverView>
                <DashboardStatCard onClick={() => addFilter("all")} title={state.total} description={"Total Triggers"}
                                   color={"violet"}
                                   icon={faChartSimple}/>
                <DashboardStatCard onClick={() => addFilter("active")} title={state.active}
                                   description={"Active Triggers"}
                                   color={"teal"}
                                   icon={faStar}/>
                <DashboardStatCard onClick={() => addFilter("scheduled")} title={state.scheduled}
                                   description={"Scheduled Triggers"}
                                   color={"blue"}
                                   icon={faCalendar}/>
                <DashboardStatCard onClick={() => addFilter("reactive")} title={state.reactive}
                                   description={"Reactive Triggers"}
                                   color={"cyan"}
                                   icon={faWater}/>
                <DashboardStatCard onClick={() => addFilter("inactive")} title={state.inactive}
                                   description={"Inactive Triggers"}
                                   color={"gray"}
                                   icon={faBan}/>
            </DashboardOverView>

            {/*<div className={"smart-trigger-heading"}>*/}

            {/*    <div className={"smart-trigger-filters"}>*/}
            {/*        {state.filters.map(name => (*/}
            {/*            <Badge key={"badge-" + name} variant="outline" sx={{paddingLeft: 3}}*/}
            {/*                   rightSection={removeButton(name)}>*/}
            {/*                {name}*/}
            {/*            </Badge>*/}
            {/*        ))}*/}
            {/*        {state.filters.length > 0 &&*/}
            {/*        <Badge key={"badge-removeAll"} variant="outline" sx={{paddingLeft: 3}}*/}
            {/*               rightSection={removeButton("all")}>*/}
            {/*            Clear*/}
            {/*        </Badge>}*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className={"smart-trigger-dashboard-flows"}>
                <div className={"smart-trigger-dashboard-folders"}>
                    <div className={"smart-trigger-dashboard-folders-title"}>
                        <h4>Folders</h4>
                        <CirclePlus/>
                    </div>

                </div>

                <div className={"smart-trigger-dashboard-content"}>
                    {
                        state.configurations
                            .filter(config => filterConfiguration(config, state.filters))
                            .map(config => (
                                <SmartTriggerCard key={config.id} color={pickRandomColor()} {...config}/>
                            ))
                    }
                    <AddNewSmartTriggerCard/>
                </div>
            </div>


        </>
    );

}
